<template>
  <b-col :class="`${is_in_sidebar ? 'd-none' : 'd-none d-lg-block position-proposal'} p-0`">
    <div class="d-flex justify-content-center" v-if="!is_in_sidebar">
      <template v-if="loading">
        <b-skeleton type="avatar" class="avatars-skeleton"/>
        <div class="ml-1 text-left w-100">
          <b-skeleton width="55%" height="18px" class="mb-1" />
          <b-skeleton width="38%" height="14px" class="mb-1" />
          <b-skeleton width="100%" height="90px" class="mt-1 rounded" />
        </div>
      </template>

      <template v-else>
        <b-link @click="$emit('redirect-vanity')">
          <b-avatar size="55px" :src="verifyAsset(proposal.user.avatar)"></b-avatar>
        </b-link>
        <div class="ml-1 text-left">
          <strong class="mr-2 cursor-pointer" @click="$emit('redirect-vanity')">
            {{ proposal.user.first_name }} {{ proposal.user.last_name }}
            <b-badge pill :class="getColorPlan(string_key)" :variant="getColorPlan(string_key)" v-if="string_key">
              <span class="size-text-pro-proposal">{{ string_key }}</span>
            </b-badge>
          </strong>
          <div v-if="details.external_agency" class="d-flex align-items-center mt-1">
            <b-link v-if="details.external_agency.url" :href="details.external_agency.url" target="_blank" class="mr-1 text-dark">Vía {{ details.external_agency.name }}</b-link>
            <span class="mr-1" v-else>Vía {{ details.external_agency.name }}</span>
            <b-avatar size="30px" :src="verifyAsset(details.external_agency.image_url)" />
          </div>
          <div class="message-contact">
            <p class="avenir-medium">{{ $t('creator.anyQuestions') }}</p>
            <b-button variant="primary" @click="$emit('message-action')" v-if="!is_your_proposal" class="mb-1 w-100">
              {{ !is_authenticated ? $t('creator.loginMessage') : $t('creator.messageMe') }}
            </b-button>
            <b-button variant="light" class="mb-1 w-100" v-if="vanity_name" @click="$emit('redirect-vanity')">
              {{ $t('creator.seeAllMetrics') }}
            </b-button>
          </div>
        </div>
      </template>
    </div>

    <div class="list-overview list-checkout d-none d-lg-block">
      <template v-if="loading">
        <b-skeleton width="50%" height="22px" class="mb-2" />
        <b-skeleton width="75%" height="14px" class="mb-3" />
        <div class="d-flex justify-content-between mb-2">
          <b-skeleton width="55%" height="18px" />
          <b-skeleton width="28%" height="18px" />
        </div>
        <div class="d-flex mb-3">
          <b-skeleton width="30%" height="14px" class="mr-2" />
          <b-skeleton width="30%" height="14px" class="mr-2" />
          <b-skeleton width="25%" height="14px" />
        </div>
        <b-skeleton width="100%" height="1px" class="mb-2" />
        <div class="d-flex justify-content-between mb-1">
          <b-skeleton width="38%" height="18px" />
          <b-skeleton width="32%" height="18px" />
        </div>
        <div class="d-flex justify-content-between mb-3">
          <b-skeleton width="38%" height="18px" />
          <b-skeleton width="32%" height="18px" />
        </div>
        <div class="d-flex justify-content-center mt-1 mb-1">
          <b-skeleton width="66%" height="45px" class="rounded" />
        </div>
        <b-skeleton width="100%" height="56px" class="mt-2 rounded" />
      </template>

      <template v-else>
      <h5 class="border-bottom pb-1">{{ $t('creator.listingOverview') }}</h5>
      <div class="w-100 text-left text-secondary avenir-medium mb-05">{{ $t('creator.previewDeal') }}</div>
      <div class="d-flex justify-content-between m-0">
        <div class="d-flex mb-2 mr-2 text-wrap text-left avenir-bold">
          {{ deal_selected.title }}
        </div>
        <div class="d-flex align-items-left ml-auto avenir-bold">
          <span v-if="!is_brandme_talent" class="d-flex text-nowrap">$ {{ separatebycomma(deal_selected.price) }} USD</span>
          <span v-else class="d-flex text-nowrap">
            <span v-for="index in deal_selected.range_price" :key="index">$</span>
          </span>
        </div>
      </div>
      <p class="d-flex flex-wrap">
        <span class="d-flex align-items-center mr-1">
          <b-icon icon="shield-check" class="mr-05" />
          <span class="avenir-medium ml-02" v-if="deal_selected.licensing">{{ $t('creator.licensing').find((licence) => licence.value === deal_selected.licensing).text }}</span>
        </span>
      </p>

      <p class="border-top"></p>
      <p v-if="!is_brandme_talent && apply_balance" class="d-flex justify-content-between m-0">
        <strong>
          <span class="d-flex align-items-center text-primary">
            {{ $t('creator.discountBalance') }}
            <feather-icon icon="TrashIcon" class="ml-1 cursor-pointer text-danger" @click="$emit('delete-discount')" />
          </span>
        </strong>
        <strong class="text-primary"> $ {{ numberFormat(balance_discount, true) }} USD </strong>
      </p>
      <p class="d-flex justify-content-between m-0 align-items-center">
        <strong>{{ $t('creator.dealSubtotal') }}</strong>
        <strong v-if="!is_brandme_talent">
          $ {{ apply_balance ? numberFormat(total_discounted, true) : numberFormat(getTotal(checked_options, deal_selected), true) }} USD
        </strong>
        <strong v-else>
          <span v-for="index in 4" :key="index">$</span>
        </strong>
      </p>
      <p v-if="is_authenticated && !is_brandme_talent && !apply_balance && get_balance > 0 && is_brand" class="d-flex justify-content-between">
        <strong>{{ $t('creator.applyBalanceCheck') }}
          <b-icon icon="plus-circle" class="cursor-pointer text-primary" @click="$emit('update:view_change_balance', !view_change_balance)" />
        </strong>
        <strong>{{ $t('creator.balance') }} $ {{ numberFormat(get_balance, true) }} USD </strong>
      </p>

      <div class="col-12 mb-1" v-if="view_change_balance">
        <b-form-group>
          <b-form-input
            :value="balance_discount"
            :placeholder="$t('creator.balance')"
            autocomplete="off"
            @input="$emit('update:balance_discount', $event)"
            @keypress="$emit('only-numbers', $event)"
          />
        </b-form-group>
        <div class="d-flex justify-content-end mt-2">
          <b-button
            @click="$emit('apply-discount')"
            :disabled="!isDiscountValid(balance_discount, get_balance, checked_options, deal_selected)"
            variant="primary"
          >
            {{ $t('creator.applyDiscount') }}
          </b-button>
        </div>
      </div>

      <div class="col-12 d-flex justify-content-center mt-1">
        <b-button
          :class="`${!buy_loader ? 'btn-buy' : 'btn-hover'} mb-1 col-8`"
          @click="$emit('buy-action')"
          :disabled="!!$route.query.uuid"
          v-if="!is_your_proposal"
        >
          <span v-if="!buy_loader">
            {{ !is_authenticated ? $t('creator.LoginToBuy') : (is_brandme_talent ? $t('creator.requestPrice') : $t('creator.buyNow')) }}
          </span>
          <b-spinner small class="mt-0" v-if="buy_loader"></b-spinner>
        </b-button>
      </div>

      <p class="text-left font-size-12" v-if="!is_your_proposal">
        <span>{{ $t('pricesInMXM') }}</span>
        <span class="avenir-black d-block">{{ $t('creator.clickBuy') }}</span>
        <span class="avenir-medium">{{ $t('creator.refunded7days') }}</span>
      </p>
      </template>
    </div>
  </b-col>
</template>

<script>
import { BCol, BLink, BAvatar, BBadge, BButton, BIcon, BFormGroup, BFormInput, BSpinner, BSkeleton } from 'bootstrap-vue'
import { verifyAsset } from '@/libs/utils/urls'
import { separatebycomma, numberFormat } from '@/libs/utils/formats'
import { getColorPlan } from '@/libs/utils/icons'
import { getTotal, isDiscountValid } from '@/domain/proposal/proposal.domain'

export default {
  name: 'resumeProposalCheckout',
  components: {
    BCol,
    BLink,
    BAvatar,
    BBadge,
    BButton,
    BIcon,
    BFormGroup,
    BFormInput,
    BSpinner,
    BSkeleton,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    is_brandme_talent: {
      type: Boolean,
      default: false,
    },
    is_in_sidebar: {
      type: Boolean,
      default: false,
    },
    proposal: {
      type: Object,
      required: true,
    },
    vanity_name: {
      type: String,
      default: '',
    },
    string_key: {
      type: String,
      default: null,
    },
    deal_selected: {
      type: Object,
      required: true,
    },
    checked_options: {
      type: Array,
      default: () => [],
    },
    apply_balance: {
      type: Boolean,
      default: false,
    },
    balance_discount: {
      default: 0,
    },
    total_discounted: {
      type: Number,
      default: 0,
    },
    buy_loader: {
      type: Boolean,
      default: false,
    },
    is_your_proposal: {
      type: Boolean,
      default: false,
    },
    is_authenticated: {
      default: null,
    },
    is_brand: {
      type: Boolean,
      default: false,
    },
    get_balance: {
      type: Number,
      default: 0,
    },
    view_change_balance: {
      type: Boolean,
      default: false,
    },
    details: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
    }
  },
  methods: {
    verifyAsset,
    separatebycomma,
    numberFormat,
    getColorPlan,
    getTotal,
    isDiscountValid,
  },
}
</script>

<style scoped lang="scss">
.avatars-skeleton {
  height: 55px;
  width: 55px;
  flex-shrink: 0;
}
.size-text-pro-proposal {
  font-size: 8.5px;
  text-transform: uppercase;
}
.mb-05 {
  margin-bottom: 0.5em;
}
.ml-02 {
  margin-left: 0.2em;
}
.font-size-12 {
  font-size: 12px;
  color: #6c757d;
}
.message-contact {
  margin: 1em 0 0 0;
  position: relative;
  height: auto;
  width: 100%;
  padding: 1em;
  background: #e9ecef;
  border-radius: 1em;

  &:before {
    border: 10px solid #e9ecef;
    content: '';
    border-left-color: transparent;
    border-bottom-color: transparent;
    border-right-color: transparent;
    position: absolute;
    top: 0px;
    left: -8px;
  }
}
.list-overview {
  padding: 1em;
  border: 1px solid #eee5e5;
  margin: 2em 0;
  border-radius: 1em;
  background-color: white;
  position: sticky;
  position: -webkit-sticky;
  top: 12em;
}
.btn-buy {
  height: 45px !important;
  padding: 4px 1em !important;
  background-color: #3483fa !important;
  border-color: transparent !important;
}
.btn-hover {
  background-color: #3483fa !important;
  border-color: transparent !important;
}
.btn-buy:hover {
  background-color: #2968c8 !important;
  border-color: transparent !important;
}
</style>
